import { cn } from "@/lib/utils";
import { ForwardRefExoticComponent, RefAttributes } from "react";

export type ShopifyIconProps = {
  className?: React.HTMLAttributes<SVGSVGElement>['className'];
  size?: string | number;
};

export type ShopifyIconType = ForwardRefExoticComponent<Omit<ShopifyIconProps, 'ref'> & RefAttributes<SVGSVGElement>>;

export function ShopifyIcon({ className }: ShopifyIconProps) {
  return (
    <object type="image/svg+xml" data="/shopify.svg" className={cn("w-4 h-4 pointer-events-none", className)} />
  );  
}
